import classNames from 'classnames'
import {sendPasswordResetEmail} from 'firebase/auth'
import {t} from 'i18next'
import {Button} from 'primereact/button'
import {Dialog} from 'primereact/dialog'
import {InputText} from 'primereact/inputtext'
import {Toast} from 'primereact/toast'
import React, {useEffect, useRef} from 'react'
import {Controller, useForm} from 'react-hook-form'
import {auth} from '../../../App'
import {getEmailRules} from '../../../util/validation/emailRules'
import {getFormErrorMessage} from '../ErrorText'

export function ResetPasswordDialog(
	props: {
		visible: boolean,
		onClose: () => void,
		email: string
	}
): JSX.Element {
	const toast = useRef<Toast>(null)

	const successfullyReset = () => {
		toast?.current?.show({
			className: '',
			closable: true,
			content: undefined,
			contentClassName: '',
			contentStyle: undefined,
			sticky: true,
			style: undefined,
			severity: 'success',
			summary: t<string>('core.action.password_reset.successful.title'),
			detail: t<string>('core.action.password_reset.successful.message'),
			life: 10000
		})
	}

	const failedToReset = () => {
		toast?.current?.show({
			className: '',
			closable: true,
			content: undefined,
			contentClassName: '',
			contentStyle: undefined,
			sticky: true,
			style: undefined,
			severity: 'warn',
			summary: t<string>('core.action.password_reset.failed.title'),
			detail: t<string>('core.action.password_reset.failed.message'),
			life: 8000
		})
	}


	const defaultValues = {
		email: props.email ? props.email : ''
	}

	const {control, formState: {errors}, setValue, handleSubmit} = useForm(
		{defaultValues}
	)

	useEffect(() => {
		if(!props.email) {
			setValue('email', '')
			return
		}
		setValue('email', props.email)

	}, [props.email])

	const onPasswordForgottenSubmit = async (emailObject: any) => {
		try {
			await sendPasswordResetEmail(auth, emailObject?.email)
			console.log('successfully Created the reset email.')
			successfullyReset()
			props.onClose()
		} catch (error: any) {
			//console.error('error occurred on password reset:' + error?.message);
			failedToReset()
		}
	}

	return (
		<div>
			<Dialog
				visible={props.visible}
				onHide={props.onClose}
				header={t<string>('core.form.password_reset')}
				className={'p-dialog'}
				style={{minWidth: '400px', minHeight: '290px'}}
				position={'top'}
			>
				<span className={'secondary-text mb-2'}>{t<string>('core.sign_in.reset_help_text')}</span>
				<form onSubmit={handleSubmit(onPasswordForgottenSubmit)}>
					<div className="mt-3 mb-2 p-fluid">
						<label
							htmlFor="email"
							className={classNames({'p-error': !!errors.email})}>{t<string>('person.email')}*</label>
						<span className=" p-input-icon-right">
							<i className="pi pi-envelope"/>
							<Controller
								name="email" control={control}
								rules={getEmailRules()}
								render={({field, fieldState}) => (
									<InputText
										id={field.name}

										{...field}
										value={field.value}

										className={classNames({'p-invalid': fieldState.error})}
									/>
								)}/>
						</span>
						{getFormErrorMessage(errors, 'email')}
					</div>
					<Button type="submit" label={t<string>('core.form.password_reset')} className="col-12 mt-2"/>
				</form>
			</Dialog>
			<Toast ref={toast} position={'bottom-right'}/>
		</div>
	)
}